var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center h-full flex-col"},[_c('div',{staticClass:"flex items-center type-scale-5 text-gray-80"},[_c('i',{staticClass:"material-icons mr-4"},[_vm._v(_vm._s(_vm.icon))]),_vm._t("default")],2),_c('p',{staticClass:"text-gray-50"},[_vm._t("helper")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }